import React from 'react'
import { Box, Button, Tooltip } from '@indeed/ifl-components'
import { Information } from '@indeed/ifl-icons'

import type { LabelWithInfoProps } from './LabelWithInfo.types'

export const WAITLISTED_TOOLTIP = 'Includes workers who applied and workers who joined a waitlist.'

export const LabelWithInfo = ({ label, info, accessibleName }: LabelWithInfoProps) => (
  <Box as="span" sx={{ display: 'inline-flex', alignItems: 'center', gap: 1 }}>
    <Box as="span" sx={{ whiteSpace: 'nowrap' }}>
      {label}
    </Box>
    <Tooltip delay={400} label={info}>
      <Button
        iconOnly
        variant="tertiary"
        aria-label={accessibleName}
        sx={{ p: 0, width: '20px', height: '20px', minHeight: '20px' }}
        size="sm"
      >
        <Information aria-hidden size="sm" color="grey" />
      </Button>
    </Tooltip>
  </Box>
)
